module.exports = __webpack_public_path__ + "static/img/全景环视-banner.95f3275.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type1-2/全景环视-banner.png
// module id = sONC
// module chunks = 0